// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__7YI7P","footer":"ModalUpdate_footer__15kIt"};